import React, { useState, useEffect } from 'react';
import './Pokemon.css';

const Pokemon = ({ name, fullHP, currentHP, level, back, hitAnimation }) => {

    const imageLoaded = (event) => {
        event.target.parentElement.style.background = "none";
        event.target.parentElement.style.display = "block";
    }   

    return (
        <div className={`Pokemon ${back ? "Back" : "Front"}`}>
            <div className="Pokemon-image">
                <div className="platform" style={{ display: name ? 'block' : 'none' }}>
                    
                </div>
                <img className={hitAnimation ? "hit-anim" : ""} src={name ? `http://www.pokestadium.com/sprites/xy/${back ? 'back/': ""}${name}.gif` : null} alt="" onLoad={imageLoaded} />
            </div>
            <div className="Pokemon-info">
                <div className="Top-info">
                    <div className="Name">{name}</div>
                    <div className="Level">Lvl {level}</div>
                </div>
                <div className="Hp-title">
                    <div>HP</div>
                    <div>{back && `${currentHP}/${fullHP}`}</div>
                </div>
                <div className="Hp-shadow">
                    <div className="Hp" style={{width: `${((currentHP/fullHP) * 100)}%`}}></div>
                </div>
            </div>
        </div>
    );

}

export default Pokemon;
